import React from 'react'
import CopyButton from '../molecules/CopyButton'
import './ResultBox.css'

const ResultBox = ({ 
  title, 
  value, 
  showCopy = true, 
  className = '',
  children,
  ...props 
}) => {
  const classes = [
    'result-box',
    className
  ].filter(Boolean).join(' ')

  return (
    <div className={classes} {...props}>
      {title && <h3 className="result-box-title">{title}</h3>}
      <div className="result-box-content">
        {children || (
          <div className="result-box-value">
            <span className="result-box-text">{value}</span>
            {showCopy && value && (
              <CopyButton text={value} />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default ResultBox
